// @ts-nocheck

export const LocalStorageAnimationsKeys = {
  SHOULD_ANIMATE_ODDS_TRAVEL: 'cache:betting:animations:shouldAnimateOddsTravel',
};
